// extracted by mini-css-extract-plugin
export var container = "newsletter-module--container---6zW9";
export var content = "newsletter-module--content--LdaWh";
export var contentWrapper = "newsletter-module--content-wrapper--e4WbE";
export var disclaimer = "newsletter-module--disclaimer--prBQ8";
export var formWrapper = "newsletter-module--form-wrapper--5S4aU";
export var headshot = "newsletter-module--headshot--V-y6Y";
export var inputWrapper = "newsletter-module--input-wrapper--mLYwe";
export var newsletterHeadline = "newsletter-module--newsletter-headline--wYMky";
export var outputText = "newsletter-module--output-text--xKlDl";
export var red = "newsletter-module--red--dYVqY";
export var submitButton = "newsletter-module--submit-button--JG-fS";
export var wrapper = "newsletter-module--wrapper--kTbLn";